import { useEffect, useState } from 'react';
// import { appInsights, reactPlugin } from '../../../appInsights';
// import { withAITracking } from '@microsoft/applicationinsights-react-js';
import cn from 'clsx';
import { SelectChangeEvent } from '@mui/material';
import { smartActionsStyles } from './smartActionsStylesStyles';
import CancelSharpIcon from '@mui/icons-material/CancelSharp';
import Button from '@mui/material/Button';
import { SelectComponent } from '../../uiComponents';
import { OptionProps } from '../../../view-models';
import { useSelector } from 'react-redux';
import { getNodes, getUserJourneys } from '../../../store';

interface popupProps {
  userJourneyIndex: number;
  nodeData: any;
  close: any;
}

function SmartActionOTP({ userJourneyIndex, nodeData, close }: popupProps) {
  const [actionData, setActionData] = useState(nodeData.data.data);
  const [sheet, setSheet] = useState<number>(0);
  const [options, setOptions] = useState<OptionProps[]>([]);
  const [orchSteps, setOrchSteps] = useState<OptionProps[]>([]);
  const [step1Selection, setStep1Selection] = useState<string>('');
  const [step2Selection, setStep2Selection] = useState<string>('');
  const initialNodes = useSelector(getNodes);
  const userJourneys = useSelector(getUserJourneys);

  useEffect(() => {
    const _temp: any = [];
    let step1Set = false;
    let step2Set = false;
    userJourneys.length > userJourneyIndex + 1 &&
      (userJourneys[userJourneyIndex]['orchestrationSteps'] || []).forEach((orchStep: any, index: number) => {
        if (index === userJourneys[userJourneyIndex]['orchestrationSteps'].length - 1) return;
        const label =
          orchStep['order'] +
          '-' +
          (orchStep['claimsExchanges'] || []).reduce(
            (acc: string, curVal: any) => (acc += curVal['technicalProfilerefrenceId']),
            [],
          );
        if (!step1Set && orchStep['type'] === 'CombinedSignInAndSignUp') {
          step1Set = true;
          setStep1Selection(label);
        }
        if (!step2Set && orchStep['type'] === 'ClaimsExchange') {
          step2Set = true;
          setStep2Selection(label);
        }
        _temp.push({ label: label, value: label });
      });

    setOrchSteps(_temp);
  }, [userJourneys]);

  useEffect(() => {
    const filteredNodes = initialNodes.filter((el) => el.type !== 'decision');
    const _options: OptionProps[] = filteredNodes.map((el: any, index: number) => {
      return { value: '' + index, label: el['data']['label'] };
    });
    setOptions(_options);
  }, [initialNodes]);

  const closePopup = () => {
    // const res = { ...nodeData, data: { data: actionData } };
    close(null);
  };

  const classes = smartActionsStyles();

  return (
    <>
      <div className={classes.popup}>
        <div className={cn(classes.header)}>
          <div className={classes.flexRow}>
            <div className={classes.actionName}>Smart Action - OTP </div>
          </div>
          <div>
            <CancelSharpIcon onClick={closePopup} color="error" sx={{ cursor: 'pointer' }} />
          </div>
        </div>

        <div className={cn(classes.flexRow, classes.policyBody)}>
          <section className={classes.content}>
            {sheet === 0 && (
              <div>
                <p>This wizard will guide you through the set up of OTP authentication.</p>
                <br />
                <p>We will need the following inputs from you:</p>
                <p>Step number of the orchestration step that does combined sign in and sign up</p>
                <p>Step number of the orchestration step that does the social sign in</p>
                <br />
                <p>The output from this will be the following:</p>
                <p>objectid of the verified user stored in the claim objectId</p>
                <p>"True" stored in the claim OTPPerformed</p>
                <br />
                <p>Let us walk you through to collect it.</p>
                <br />
                <p>
                  Click <b>Next</b> to continue.
                </p>
              </div>
            )}
            {sheet === 1 && (
              <div>
                <p>We have sensed that the following is your CombinedSignInAndSignUp Step : </p>
                <p>
                  <b>{step1Selection}</b>
                </p>

                <p>If that is incorrect please choose your step from the following:</p>
                <SelectComponent
                  changeHandler={(e: SelectChangeEvent<string>) => {
                    setStep1Selection(e.target.value);
                  }}
                  data={{
                    value: step1Selection,
                    label: 'Step Number - TechnicalProfileReferenceId',
                    options: orchSteps,
                  }}
                />
                <p>
                  Click <b>Next</b> to continue.
                </p>
              </div>
            )}
            {sheet === 2 && (
              <div>
                <p>We have auto sensed that the following step does your social authentication</p>
                <p>
                  <b>{step2Selection}</b>
                </p>
                <p>If that is incorrect please choose your step from the following:</p>
                <SelectComponent
                  changeHandler={(e: SelectChangeEvent<string>) => {
                    setStep2Selection(e.target.value);
                  }}
                  data={{
                    value: step2Selection,
                    label: 'Step Number - TechnicalProfileReferenceId',
                    options: orchSteps,
                  }}
                />
                <p>
                  Click <b>Next</b> to continue.
                </p>
              </div>
            )}
            {sheet === 3 && (
              <div>
                <p>You are complete. </p>
                <p>We have auto injected the code. </p>
                <p>If you choose to revert this you can do so from the left hand menu.</p>
              </div>
            )}
          </section>
          <footer className={classes.footer}>
            {sheet === 3 && (
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  close({ step1Selection, step2Selection });
                }}
              >
                Complete
              </Button>
            )}
            {sheet <= 2 && (
              <Button
                variant="contained"
                color="primary"
                onClick={() => {
                  setSheet(sheet + 1);
                }}
              >
                Next
              </Button>
            )}
            {sheet > 0 && sheet <= 3 && (
              <Button
                variant="contained"
                color="error"
                onClick={() => {
                  setSheet(sheet - 1);
                }}
              >
                Back
              </Button>
            )}
          </footer>
        </div>
      </div>
    </>
  );
}

// export default withAITracking(reactPlugin, SmartActionOTP);
export default SmartActionOTP;
